import React from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-white/10 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5 mb-4">
              <Flame className="w-6 h-6 text-[#E8954A]" strokeWidth={2.2} />
              <span className="font-display font-extrabold tracking-tight text-lg uppercase">Iron Fire Productions</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed">
              An independent studio developing bold screenplays, series, and reality concepts for film and television.
            </p>
          </div>
          <div className="flex gap-16">
            <div>
              <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40 mb-4">Explore</p>
              <ul className="space-y-3 text-sm text-white/65">
                <li><a href="/#work" className="hover:text-white transition-colors">Projects</a></li>
                <li><a href="/#studio" className="hover:text-white transition-colors">The Studio</a></li>
                <li><a href="/#contact" className="hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
            <div>
              <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40 mb-4">Industry</p>
              <ul className="space-y-3 text-sm text-white/65">
                <li><a href="/#work" className="hover:text-white transition-colors">Request a Screenplay</a></li>
                <li><a href="/#work" className="hover:text-white transition-colors">Request Full Pitch</a></li>
                <li><Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white transition-colors">Admin</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Iron Fire Productions. All rights reserved.</p>
          <p>Screenplays & concepts are confidential and protected.</p>
        </div>
      </div>
    </footer>
  );
}
